import { render } from "./FormulaListElement.vue?vue&type=template&id=55950136&ts=true"
import script from "./FormulaListElement.vue?vue&type=script&lang=ts"
export * from "./FormulaListElement.vue?vue&type=script&lang=ts"

import "./FormulaListElement.vue?vue&type=style&index=0&id=55950136&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPopupEdit,QInput,QBtn,QTooltip,QItem});
